export default "__VITE_ASSET__DIWN8RhN__"